import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

export default class QuickLinks extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  className() {
    return 'quick-links-widget';
  }

  content() {
    return (
      <div id="quick-links-widget">
        <h4>Quick-Links</h4>
        <ul>
          <li>
            <a target="_blank" href="https://www.busch-jaeger.de/online-katalog">
              Zum Onlinekatalog
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.busch-jaeger.de/">
              Busch-Jaeger.de
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.busch-jaeger.de/mediathek?tx_solr%5Bfilter%5D%5B0%5D=media_type%3Aapps">
              Apps
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
